import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Calculator, Briefcase, Hammer, Coins, TrendingUp } from 'lucide-react';

const jobsList = [
  { title: 'القيادة العامة للشرطة', desc: 'تطبيق النظام وحفظ الأمن داخل المقاطعة.', color: 'from-blue-500/20' },
  { title: 'وزارة الصحة', desc: 'إنقاذ الأرواح وتقديم الرعاية الطبية الفورية.', color: 'from-red-500/20' },
  { title: 'كراج الميكانيك', desc: 'إصلاح وصيانة المركبات وتعديلها بأحدث التقنيات.', color: 'from-yellow-500/20' },
];

const farmJobsData = [
  {
    id: 'oil', name: 'النفط والغاز', reqLevel: 130, icon: '⛽',
    items: [{ id: 'gas', name: 'غاز', basePrice: 300, baseXp: 11 }, { id: 'oil_item', name: 'نفط', basePrice: 400, baseXp: 12 }],
    upgrades: [
      'من لفل 1 إلى 2: 2250 اسطوانة | زيادة $50',
      'من لفل 2 إلى 3: 3750 اسطوانة | زيادة 1 خبرة',
      'من لفل 3 إلى 4: 3750 اسطوانة | زيادة $100',
      'من لفل 4 إلى 5: 5250 اسطوانة | زيادة 1 خبرة',
    ]
  },
  {
    id: 'mineral', name: 'المعادن', reqLevel: 100, icon: '⛏️',
    items: [{ id: 'copper', name: 'نحاس', basePrice: 200, baseXp: 7 }, { id: 'iron', name: 'حديد', basePrice: 200, baseXp: 8 }, { id: 'gold', name: 'ذهب', basePrice: 400, baseXp: 9 }, { id: 'diamond', name: 'ألماس', basePrice: 11500, baseXp: 30 }],
    upgrades: [
      'من لفل 1 إلى 2: 1500 معادن | زيادة $50',
      'من لفل 2 إلى 3: 2500 معادن | زيادة 1 خبرة',
      'من لفل 3 إلى 4: 2500 معادن | زيادة $100',
      'من لفل 4 إلى 5: 3500 معادن | زيادة 1 خبرة',
    ]
  },
  {
    id: 'pasture', name: 'المراعي', reqLevel: 65, icon: '🥛',
    items: [{ id: 'milk', name: 'حليب', basePrice: 280, baseXp: 9 }],
    upgrades: [
      'من لفل 1 إلى 2: 1500 حليب | زيادة $50',
      'من لفل 2 إلى 3: 2500 حليب | زيادة 1 خبرة',
      'من لفل 3 إلى 4: 2500 حليب | زيادة $100',
      'من لفل 4 إلى 5: 3500 حليب | زيادة 1 خبرة',
    ]
  },
  {
    id: 'wood', name: 'الأخشاب', reqLevel: 45, icon: '🪵',
    items: [{ id: 'bundle', name: 'حزمة', basePrice: 300, baseXp: 8 }],
    upgrades: [
      'من لفل 1 إلى 2: 1500 حزمة | زيادة $50',
      'من لفل 2 إلى 3: 2500 حزمة | زيادة 1 خبرة',
      'من لفل 3 إلى 4: 2800 حزمة | زيادة $100',
      'من لفل 4 إلى 5: 3200 حزمة | زيادة 1 خبرة',
    ]
  },
  {
    id: 'poultry', name: 'الدواجن', reqLevel: 30, icon: '🐔',
    items: [{ id: 'chicken', name: 'دجاجة', basePrice: 290, baseXp: 9 }],
    upgrades: [
      'من لفل 1 إلى 2: 1500 دجاجة | زيادة $50',
      'من لفل 2 إلى 3: 2500 دجاجة | زيادة 1 خبرة',
      'من لفل 3 إلى 4: 2500 دجاجة | زيادة $100',
      'من لفل 4 إلى 5: 3500 دجاجة | زيادة 1 خبرة',
    ]
  },
  {
    id: 'apiary', name: 'المناحل', reqLevel: 20, icon: '🍯',
    items: [{ id: 'honey', name: 'عسل', basePrice: 300, baseXp: 7 }],
    upgrades: [
      'من لفل 1 إلى 2: 1500 عسل | زيادة $50',
      'من لفل 2 إلى 3: 2500 عسل | زيادة 1 خبرة',
      'من لفل 3 إلى 4: 2500 عسل | زيادة $100',
      'من لفل 4 إلى 5: 3500 عسل | زيادة 1 خبرة',
    ]
  },
  {
    id: 'fabric', name: 'الأقمشة', reqLevel: 15, icon: '🧵',
    items: [{ id: 'clothes', name: 'ملابس', basePrice: 390, baseXp: 12 }],
    upgrades: [
      'من لفل 1 إلى 2: 1125 ملابس | زيادة $50',
      'من لفل 2 إلى 3: 1875 ملابس | زيادة 1 خبرة',
      'من لفل 3 إلى 4: 1875 ملابس | زيادة $100',
      'من لفل 4 إلى 5: 2625 ملابس | زيادة 1 خبرة',
    ]
  },
  {
    id: 'grape', name: 'الاعناب', reqLevel: 0, icon: '🍇',
    items: [{ id: 'juice', name: 'عصير', basePrice: 220, baseXp: 7 }],
    upgrades: [
      'من لفل 1 إلى 2: 375 عصير | زيادة $50',
      'من لفل 2 إلى 3: 625 عصير | زيادة 1 خبرة',
      'من لفل 3 إلى 4: 625 عصير | زيادة $100',
      'من لفل 4 إلى 5: 875 عصير | زيادة 1 خبرة',
    ]
  }
];

export default function Jobs() {
  const [activeTab, setActiveTab] = useState('farm');
  
  // حالات الحاسبة
  const [calcJobId, setCalcJobId] = useState(farmJobsData[0].id);
  const [calcItemId, setCalcItemId] = useState(farmJobsData[0].items[0].id);
  const [calcLevel, setCalcLevel] = useState(1);
  const [calcAmount, setCalcAmount] = useState(1);

  const selectedJob = farmJobsData.find(j => j.id === calcJobId) || farmJobsData[0];
  const selectedItem = selectedJob.items.find(i => i.id === calcItemId) || selectedJob.items[0];

  const handleJobChange = (e) => {
    const newJob = farmJobsData.find(j => j.id === e.target.value);
    setCalcJobId(newJob.id);
    setCalcItemId(newJob.items[0].id);
  };

  // المنطق الرياضي لزيادات الفلوس والخبرة بناءً على اللفل
  let bonusPrice = 0;
  let bonusXp = 0;
  if (calcLevel >= 2) bonusPrice += 50;
  if (calcLevel >= 3) bonusXp += 1;
  if (calcLevel >= 4) bonusPrice += 100; // الإجمالي +150
  if (calcLevel >= 5) bonusXp += 1; // الإجمالي +2

  const finalPricePerItem = selectedItem.basePrice + bonusPrice;
  const finalXpPerItem = selectedItem.baseXp + bonusXp;

  const totalMoney = finalPricePerItem * calcAmount;
  const totalXp = finalXpPerItem * calcAmount;

  return (
    <section id="الوظائف" className="pt-32 pb-24 min-h-screen relative bg-black">
      <div className="absolute top-0 left-0 w-96 h-96 bg-neon-cyan/5 rounded-full blur-[150px] pointer-events-none"></div>
      <div className="container mx-auto px-6 z-10 relative">
        <h2 className="text-4xl md:text-6xl font-black text-center mb-16 text-white tracking-wide">
          القطاعات <span className="text-neon-cyan">الوظيفية</span>
        </h2>

        {/* أزرار التبويب */}
        <div className="flex flex-wrap justify-center gap-4 mb-16">
          <button onClick={() => setActiveTab('gov')} className={`px-8 py-3 rounded-full font-bold transition-all duration-300 flex items-center gap-2 ${activeTab === 'gov' ? 'bg-neon-cyan text-black shadow-neon' : 'bg-black/50 text-white border border-white/10 hover:border-neon-cyan/50'}`}>
            <Briefcase size={20} />
            القطاعات الحكومية
          </button>
          <button onClick={() => setActiveTab('farm')} className={`px-8 py-3 rounded-full font-bold transition-all duration-300 flex items-center gap-2 ${activeTab === 'farm' ? 'bg-neon-purple text-white shadow-neon-purple' : 'bg-black/50 text-white border border-white/10 hover:border-neon-purple/50'}`}>
            <Hammer size={20} />
            الأعمال الحرة والمزارع
          </button>
        </div>

        {/* محتوى التبويبات */}
        {activeTab === 'gov' ? (
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="grid md:grid-cols-3 gap-8">
          {jobsList.map((job, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.2 }}
              className="relative p-10 rounded-[2rem] hover:shadow-neon transition-all duration-300 overflow-hidden group"
            >
              <div className="absolute inset-[-100%] bg-[conic-gradient(from_0deg,transparent_70%,#00f3ff_80%,#bc13fe_100%)] animate-[spin_3s_linear_infinite] opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-0" />
              <div className="absolute inset-[2px] bg-[#050505]/95 backdrop-blur-xl rounded-[calc(2rem-2px)] z-0" />
              
              <div className={`absolute inset-0 bg-gradient-to-br ${job.color} to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-0`}></div>
              
              <h3 className="text-3xl font-bold mb-4 text-white relative z-10">{job.title}</h3>
              <p className="text-gray-400 leading-relaxed relative z-10">{job.desc}</p>
              <div className="mt-8 relative z-10">
                <button className="px-8 py-3 bg-black/50 border border-white/10 rounded-xl font-bold text-white hover:bg-neon-cyan hover:text-black hover:border-neon-cyan transition-all duration-300 w-full md:w-auto">
                  تقديم طلب
                </button>
              </div>
            </motion.div>
          ))}
        </motion.div>
        ) : (
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-16">
            
            {/* الحاسبة الذكية */}
            <div className="glass-panel p-8 rounded-[2.5rem] border-t border-neon-purple/30 shadow-[0_0_30px_rgba(188,19,254,0.15)] max-w-5xl mx-auto w-full">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center flex items-center justify-center gap-3">
                <Calculator className="text-neon-purple" />
                حاسبة الأرباح والخبرة (المزارع)
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                <div className="space-y-2">
                  <label className="text-gray-400 text-sm font-bold">الوظيفة</label>
                  <select value={calcJobId} onChange={handleJobChange} className="w-full bg-black/60 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-neon-purple transition-all appearance-none cursor-pointer">
                    {farmJobsData.map(j => <option key={j.id} value={j.id}>{j.icon} {j.name}</option>)}
                  </select>
                </div>
                <div className="space-y-2">
                  <label className="text-gray-400 text-sm font-bold">العنصر المراد بيعه</label>
                  <select value={calcItemId} onChange={e => setCalcItemId(e.target.value)} disabled={selectedJob.items.length === 1} className="w-full bg-black/60 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-neon-purple transition-all appearance-none cursor-pointer disabled:opacity-50">
                    {selectedJob.items.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
                  </select>
                </div>
                <div className="space-y-2">
                  <label className="text-gray-400 text-sm font-bold">مستوى الوظيفة (Level)</label>
                  <select value={calcLevel} onChange={e => setCalcLevel(Number(e.target.value))} className="w-full bg-black/60 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-neon-purple transition-all appearance-none cursor-pointer">
                    {[1, 2, 3, 4, 5].map(l => <option key={l} value={l}>المستوى {l}</option>)}
                  </select>
                </div>
                <div className="space-y-2">
                  <label className="text-gray-400 text-sm font-bold">الكمية المستخرجة</label>
                  <input type="number" min="1" value={calcAmount} onChange={e => setCalcAmount(Number(e.target.value) || 1)} className="w-full bg-black/60 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-neon-purple transition-all" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-black/40 rounded-2xl p-6 border border-green-500/20 flex items-center justify-between group hover:border-green-500/50 transition-all">
                  <div>
                    <div className="text-gray-400 text-sm mb-1">إجمالي الأرباح</div>
                    <div className="text-3xl lg:text-4xl font-black text-green-400">${totalMoney.toLocaleString()}</div>
                  </div>
                  <div className="w-16 h-16 rounded-full bg-green-500/10 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <Coins className="text-green-500" size={32} />
                  </div>
                </div>
                <div className="bg-black/40 rounded-2xl p-6 border border-blue-500/20 flex items-center justify-between group hover:border-blue-500/50 transition-all">
                  <div>
                    <div className="text-gray-400 text-sm mb-1">الخبرة المكتسبة (XP)</div>
                    <div className="text-3xl lg:text-4xl font-black text-blue-400">{totalXp.toLocaleString()}</div>
                  </div>
                  <div className="w-16 h-16 rounded-full bg-blue-500/10 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <TrendingUp className="text-blue-500" size={32} />
                  </div>
                </div>
              </div>
            </div>

            {/* كروت وظائف المزارع */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {farmJobsData.map(job => (
                <div key={job.id} className="relative p-6 rounded-[2rem] bg-[#050505]/95 border border-white/5 hover:border-neon-purple/50 transition-all duration-300 group overflow-hidden flex flex-col h-full">
                  <div className="absolute top-0 right-0 w-24 h-24 bg-neon-purple/5 rounded-bl-full -z-10 group-hover:scale-150 transition-transform duration-500"></div>
                  <div className="text-5xl mb-4">{job.icon}</div>
                  <h3 className="text-2xl font-bold text-white mb-2">{job.name}</h3>
                  <div className="inline-block px-3 py-1 bg-neon-purple/10 text-neon-purple rounded-lg text-xs font-bold mb-4 border border-neon-purple/20 self-start">مستوى الوظيفة: {job.reqLevel}</div>
                  
                  <div className="space-y-2 mb-4 border-t border-white/5 pt-4">
                    <div className="text-gray-400 text-xs font-bold">الأسعار والخبرة (المستوى 1):</div>
                    {job.items.map(i => (
                      <div key={i.id} className="flex justify-between items-center bg-white/5 px-3 py-2 rounded-lg"><span className="text-white text-sm">{i.name}</span><span className="text-neon-cyan text-xs font-mono tracking-wider">${i.basePrice} | {i.baseXp} XP</span></div>
                    ))}
                  </div>
                  
                  <div className="space-y-1 mt-auto">
                    <div className="text-gray-400 text-xs mb-2 font-bold">مراحل الترقية:</div>
                    {job.upgrades.map((upg, idx) => (
                      <div key={idx} className="text-[11px] text-gray-400 flex items-start gap-1"><span className="text-neon-purple mt-[2px]">•</span><span>{upg}</span></div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        )}
      </div>
    </section>
  );
}